import React, { useState, useEffect, useCallback } from 'react'; 
import { auth, db } from '../../Components/LoginComp/firebase';
import { collection, getDocs, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { jsPDF } from "jspdf";
import * as XLSX from 'xlsx';
import './adminpanel.css';



function AdminPanel() {
  const [activeTab, setActiveTab] = useState('viewStallBookings');
  const [users, setUsers] = useState([]);



  //fetch all abstracts  
  const [abstracts, setAbstracts] = useState([]); // State to store abstracts


  // Fetch all users
  const fetchUsers = useCallback(async () => {
    try {
      const userRef = collection(db, 'users');
      const snapshot = await getDocs(userRef);
      const usersData = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error.message);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 'viewUsers' || activeTab === 'manageUsers') {
      fetchUsers();
    }
  }, [activeTab, fetchUsers]);

  // Remove user with confirmation
  const handleRemoveUser = async (userId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this member?");
    if (!confirmDelete) return; 

    try {
      await deleteDoc(doc(db, 'users', userId));  
      setUsers(prevUsers => prevUsers.filter(user => user.id !== userId)); 
    } catch (error) {
      console.error("Error removing user:", error.message);
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };



  const handleLogout = async () => {
    try {
      await auth.signOut();
      window.location.href = '/';  
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  useEffect(() => {
    document.body.classList.add('admin-panel-active');
    return () => {
      document.body.classList.remove('admin-panel-active');
    };
  }, []);









//fetch all abstracts

  useEffect(() => {
    const fetchAbstracts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "abstracts"));
        const fetchedAbstracts = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setAbstracts(fetchedAbstracts);
      } catch (error) {
        console.error("Error fetching abstracts: ", error);
      }
    };
  
    fetchAbstracts();
  }, []);





  // In Admin.js, update the table columns and add handler functions:
const handleApprove = async (abstractId) => {
  try {
    await updateDoc(doc(db, "abstracts", abstractId), {
      status: "approved"
    });
    // Refresh the abstracts list
    fetchAbstracts();
  } catch (error) {
    console.error("Error approving abstract: ", error);
  }
};

const handleReject = async (abstractId) => {
  try {
    await updateDoc(doc(db, "abstracts", abstractId), {
      status: "rejected"
    });
    // Refresh the abstracts list
    fetchAbstracts();
  } catch (error) {
    console.error("Error rejecting abstract: ", error);
  }
};

// Update the fetchAbstracts function to include in your useEffect:
const fetchAbstracts = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "abstracts"));
    const fetchedAbstracts = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setAbstracts(fetchedAbstracts);
  } catch (error) {
    console.error("Error fetching abstracts: ", error);
  }
};




  
  // // Function to download an abstract as a .txt file
  // const handleDownload = (abstract) => {
  //   const text = `Title: ${abstract.title}\n\nAuthor: ${abstract.name}\nEmail: ${abstract.email}\n\nAbstract:\n${abstract.abstract}`;
  //   const blob = new Blob([text], { type: "text/plain" });
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = `${abstract.title.replace(/\s+/g, "_")}.txt`;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };


//fetch all the messages from the contacts
const [messages, setMessages] = useState([]);

useEffect(() => {
  const fetchMessages = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "contacts"));
      const contactMessages = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMessages(contactMessages);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  fetchMessages();
}, []);




//fetch all the booking of stall
const [bookings, setBookings] = useState([]);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "stall"));
        const stallBookings = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setBookings(stallBookings);
      } catch (error) {
        console.error("Error fetching stall bookings:", error);
      }
    };

    fetchBookings();
  }, []);






 // Function to download bookings as an XLSX file
 const downloadExcel = () => {
  const ws = XLSX.utils.json_to_sheet(
    bookings.map((booking) => ({
      Organization: booking.organization,
      Country: booking.country,
      "Contact Person": booking.contactPerson,
      Email: booking.email,
      Phone: booking.phone,
      "Stall Type": booking.stallType,
      Timestamp: booking.timestamp
        ? new Date(booking.timestamp.seconds * 1000).toLocaleString()
        : "N/A",
    }))
  );
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Stall Bookings');
  XLSX.writeFile(wb, 'stall_bookings.xlsx');
};







  return (
    <div className="admin-panel">
      <div className="top-bar">
        <ul className="tabs">
          <li className={`tab ${activeTab === 'viewStallBookings' ? 'active' : ''}`} onClick={() => handleTabClick('viewStallBookings')}>
            View Stall Bookings
          </li>
          <li className={`tab ${activeTab === 'downloadAbstract' ? 'active' : ''}`} onClick={() => handleTabClick('downloadAbstract')}>
            Download Abstracts
          </li>
          <li className={`tab ${activeTab === 'viewUsers' ? 'active' : ''}`} onClick={() => handleTabClick('viewUsers')}>
            View All Members
          </li>
          <li className={`tab ${activeTab === 'manageUsers' ? 'active' : ''}`} onClick={() => handleTabClick('manageUsers')}>
            Manage Members
          </li>
          <li className={`tab ${activeTab === 'contactMessage' ? 'active' : ''}`} onClick={() => handleTabClick('contactMessage')}>
            Contact Us Messages
          </li>
        </ul>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="main-content">



      {activeTab === "viewStallBookings" && (
        <div className="tab-content active">
          <h3>View Stall Bookings</h3>
          {bookings.length === 0 ? (
            <p>No bookings found.</p>
          ) : (
            <>
              <button onClick={downloadExcel} className="download-btn">
                Download as Excel
              </button>

              <table className="stall-table">
                <thead>
                  <tr>
                    <th>Organization</th>
                    <th>Country</th>
                    <th>Contact Person</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Stall Type</th>
                    <th>Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  {bookings.map((booking) => (
                    <tr key={booking.id}>
                      <td>{booking.organization}</td>
                      <td>{booking.country}</td>
                      <td>{booking.contactPerson}</td>
                      <td>{booking.email}</td>
                      <td>{booking.phone}</td>
                      <td>{booking.stallType}</td>
                      <td>
                        {booking.timestamp && booking.timestamp.seconds
                          ? new Date(booking.timestamp.seconds * 1000).toLocaleString()
                          : "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              
            </>
          )}
        </div>
      )}






              {activeTab === 'downloadAbstract' && (
                <div className="abstract-download-section">
                  <h3 className="download-heading">Download Abstracts</h3>
                  {abstracts.length > 0 ? (
                  <div className="abstract-table-container">
                   <table className="abstract-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Contact No</th>
                        <th>Title</th>
                        <th>Status</th>
                        <th>Uploaded File</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {abstracts.map((abstract) => (
                        <tr key={abstract.id}>
                          <td>{abstract.name}</td>
                          <td>{abstract.email}</td>
                          <td>{abstract.contactNo}</td>
                          <td>{abstract.title}</td>
                          <td>
                            <span className={`status-badge ${abstract.status || 'pending'}`}>
                              {abstract.status || 'pending'}
                            </span>
                          </td>
                          <td>
                            {abstract.fileUrl && (
                              <a href={abstract.fileUrl} target="_blank" rel="noopener noreferrer" className="file-download-link">
                                <button className="download-btn">Download File</button>
                              </a>
                            )}
                          </td>
                          <td className="action-buttons">
                            <button 
                              className="approve-btn"
                              onClick={() => handleApprove(abstract.id)}
                            >
                              Approve
                            </button>
                            <button 
                              className="reject-btn"
                              onClick={() => handleReject(abstract.id)}
                            >
                              Reject
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                    {abstracts.length === 0 && <p className="no-abstracts">No abstracts submitted yet.</p>}
                  </div>
                ) : (
                  <p className="no-abstracts">No abstracts submitted yet.</p>
                )}
              </div>
            )}





        {activeTab === 'viewUsers' && (
          <div className="tab-content active">
            <h3>View All Members</h3>
            <table className="users-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Country</th>
                  <th>Email</th>
                  <th>Contact No</th>
                  <th>Role</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.country}</td>
                    <td>{user.email}</td>
                    <td>{user.contactNo}</td>
                    <td>{user.role}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === 'manageUsers' && (
          <div className="tab-content active">
            <h3>Manage Members</h3>
            <table className="users-table">
              <thead>
                <tr>
                <th>Name</th>
                  <th>Country</th>
                  <th>Email</th>
                  <th>Contact No</th>
                  <th>Role</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.country}</td>
                    <td>{user.email}</td>
                    <td>{user.contactNo}</td>
                    <td>{user.role}</td>
                    <td>
                      <button className="remove-btn" onClick={() => handleRemoveUser(user.id)}>
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}


        {activeTab === "contactMessage" && (
            <div className="tab-content active">
            <h3>View Contact Messages</h3>
            {messages.length === 0 ? (
              <p>No messages found.</p>
            ) : (
              <table className="contact-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Message</th>
                    <th>Address</th>
                    <th>Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  {messages.map((msg) => (
                    <tr key={msg.id}>
                      <td>{msg.name}</td>
                      <td>{msg.email}</td>
                      <td>{msg.phone}</td>
                      <td>{msg.message}</td>
                      <td>{msg.address}</td>
                      <td>{new Date(msg.timestamp?.seconds * 1000).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
     
        )}


      </div>
    </div>
  );
}

export default AdminPanel;
